<template>
  <div class="data-table">
    <!-- <div class="reportag" v-if="tag === 'Energy'">
      <span class="active" >发电量时段报表</span>
    </div>
    <div class="reportag" v-else-if="tag === 'Storage'">
      <span class="active" >充放电量时段报表</span>
    </div>
    <div class="reportag" v-else>
      <span :class="{active:tag === 'PowerTime'}" @click="checkreport('PowerTime')">用电量时段报表</span>
      <span :class="{active:tag === 'PowerRange'}" @click="checkreport('PowerRange')">尖峰平谷报表</span>
      <span :class="{active:tag === 'Running'}" @click="checkreport('Running')">电力运行报表</span>
      <span :class="{active:tag === 'Extremum'}" @click="checkreport('Extremum')">电力极值报表</span>
    </div> -->
    <!-- <div class="title" v-if=" tag === 'PowerTime'">
      用电量时段报表
    </div>
    <div class="title" v-if=" tag === 'PowerRange'">
      尖峰平谷报表
    </div>
    <div class="title" v-if=" tag === 'Running'">
      电力运行报表
    </div>
    <div class="title" v-if=" tag === 'Extremum'">
      电力极值报表
    </div> -->
    <div class="menu row-center" style="justify-content:space-between">
      <div class="uleft" >
        <div class="row-center">
            <el-select
            class="nodes-tree"
            :placeholder="
              selectedNodes.length ? selectedNodes.join('、') : '选择数据类型'
            "
            v-if="
            tag == 'Running'||tag == 'Extremum'
            "
            :value="selectedNodes.length ? selectedNodes.join('、') : ''"
          >
            <el-option value="0">
              <div class="tree" :class="{ 'is-active': isActive }" @click.stop="">
                <div
                  class="option row-center"
                  style="justify-content: space-between"
                >
                  <div
                    class="row-center all"
                    @click.stop="selectAll = !selectAll"
                  >
                    <img
                      src="../../assets/img/已选.png"
                      alt=""
                      v-if="isSelectedAll"
                    />
                    <img src="../../assets/img/未选.png" alt="" v-else />
                    <span>全选</span>
                  </div>
                  <span @click.stop="clearTreeData">重置</span>
                </div>
                <div class="data" id="nodes-tree">
                  <el-tree
                    check-on-click-node
                    accordion
                    show-checkbox
                    @check="currentChange"
                    node-key="id"
                    ref="tree"
                    :data="treeData"
                  ></el-tree>
                </div>
              </div>
            </el-option>
          </el-select>

          <el-date-picker
            :editable="false"
            :picker-options="pickerOptions"
            :clearable="false"
            class="dateSelect"
            v-model="date"
            :type="radio === 'day' ? 'date' : radio"
            :placeholder="new Date().toLocaleDateString().replace(/\//g, '-')"
          >
          </el-date-picker>

        </div>
   
        <div class="row-center" :class="{both:tag=='Extremum'||tag=='Running'}">
          <div class="radio">
            <el-radio
              v-model="radio"
              label="year"
              v-if="tag != 'Extremum'"
            >
              年
            </el-radio>
            <el-radio v-model="radio" label="month">月</el-radio>
            <el-radio v-model="radio" label="day" v-if="tag !== 'PowerRange'"
              >日</el-radio
            >
          </div>
          <div class="btn per" @click="perD" v-if="radio === 'day'">上一日</div>
          <div class="btn per" @click="perM" v-if="radio === 'month'">上一月</div>
          <div class="btn per" @click="perY" v-if="radio === 'year'">上一年</div>
          <el-button
            class="btn next"
            plain
            @click="nextD"
            v-if="radio === 'day'"
            :disabled="nextDayDisabled"
            >下一日
          </el-button>
          <el-button
            class="btn next"
            plain
            @click="nextM"
            v-if="radio === 'month'"
            :disabled="nextDayDisabled"
          >
            下一月
          </el-button>
          <el-button
            class="btn next"
            plain
            @click="nextY"
            v-if="radio === 'year'"
            :disabled="nextDayDisabled"
            >下一年
          </el-button>
        </div>
      </div>
      <div class="export row-center">
        <img
          style="width: 14px; height: 14px"
          src="../../assets/img/export.png"
          alt=""
        />
        <span
          style="font-size: 14px; cursor: pointer"
          @click="
            $store.commit('exportDiagram', {
              type: 'excel',
              version: Math.random(),
            })
          "
          >导出报表</span
        >
      </div>
    </div>
    <div class="report" :class="{reporth:tag=='Extremum'||tag=='Running'}">
      <PowerTime
        v-if="tag === 'PowerTime'"
        :date="date"
        :range="radio"
        :loops="selectedLoops"
      ></PowerTime>
      <PowerRange
        v-if="tag === 'PowerRange'"
        :date="date"
        :range="radio"
        :loops="[currentLoop]"
      ></PowerRange>
      <Extremum
        v-if="tag === 'Extremum'"
        :date="date" 
        :range="radio" 
        :loops="selectedLoops" 
        :nodes="selectedNodes"
        :node-details="allNodeData"
      ></Extremum>
      <Running :date="date" :range="radio" :loops="selectedLoops" :nodes="selectedNodes"  v-if="tag === 'Running'"></Running>
      <Energy :date="date" :range="radio" :loops="selectedLoops" :nodes="selectedNodes"  v-if="tag === 'Energy'"></Energy>
      <Storage :date="date" :range="radio" :loops="selectedLoops" :nodes="selectedNodes"  v-if="tag === 'Storage'"></Storage>
    </div>
  </div>
</template>
<script>
import Running from "./report/Running";
import {
  perDay,
  perMonth,
  perYear,
  nextDay,
  nextMonth,
  nextYear,
  dateFormat,
  addDay,
  getAppointedDate
} from "../../util/DateUtil";
import PowerTime from "./report/PowerTime";
import PowerRange from "./report/PowerRange";
import Extremum from "./report/Extremum";
import Energy from "./report/Energy";
import Storage from "./report/Storage";
import exportExcel from "../../util/excel";
export default {
  name: "PowerDataBase",
  props: {
    realData: Array,
    options: Array,
    currentLoop: Object,
    selectedLoops: Array,
  },
  components: {
    Running,
    PowerTime,
    PowerRange,
    Extremum,
    Energy,
    Storage
  },
  data() {
    return {
      pickerOptions: {
        firstDayOfWeek: 1,
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      date: new Date(),
      radio: "day",
      treeData: [
        {
          id: "0",
          label: "功率因数",
          node: "PF",
          children: [
            {
              id: "0-1",
              label: "A相功率因数",
              node: "PFa",
            },
            {
              id: "0-2",
              label: "B相功率因数",
              node: "PFb",
            },
            {
              id: "0-3",
              label: "C相功率因数",
              node: "PFc",
            },
          ],
        },
        {
          id: "1",
          label: "有功功率",
          node: "PA",
          unit: "kW",
          children: [
            {
              id: "1-1",
              label: "A相有功功率",
              node: "PAa",
              unit: "kW",
            },
            {
              id: "1-2",
              label: "B相有功功率",
              node: "PAb",
              unit: "kW",
            },
            {
              id: "1-3",
              label: "C相有功功率",
              node: "PAc",
              unit: "kW",
            },
          ],
        },
        {
          id: "2",
          label: "无功功率",
          node: "PR",
          unit: "kVar",
          children: [
            {
              id: "2-1",
              label: "A相无功功率",
              node: "PRa",
              unit: "kVar",
            },
            {
              id: "2-2",
              label: "B相无功功率",
              node: "PRb",
              unit: "kVar",
            },
            {
              id: "2-3",
              label: "C相无功功率",
              node: "PRc",
              unit: "kVar",
            },
          ],
        },
        {
          id: "3",
          label: "视在功率",
          node: "P",
          unit: "kVA",
          children: [
            {
              id: "3-1",
              label: "A相视在功率",
              node: "Pa",
              unit: "kVA",
            },
            {
              id: "3-2",
              label: "B相视在功率",
              node: "Pb",
              unit: "kVA",
            },
            {
              id: "3-3",
              label: "C相视在功率",
              node: "Pc",
              unit: "kVA",
            },
          ],
        },
        {
          id: "4",
          label: "频率",
          node: "F",
          unit: "Hz",
        },
        {
          id: "5",
          label: "相电压",
          children: [
            {
              id: "5-1",
              label: "A相电压",
              node: "Ua",
              unit: "V",
            },
            {
              id: "5-2",
              label: "B相电压",
              node: "Ub",
              unit: "V",
            },
            {
              id: "5-3",
              label: "C相电压",
              node: "Uc",
              unit: "V",
            },
          ],
        },
        {
          id: "6",
          label: "线电压",
          children: [
            {
              id: "6-1",
              label: "A相线电压",
              node: "Uab",
              unit: "V",
            },
            {
              id: "6-2",
              label: "B相线电压",
              node: "Ubc",
              unit: "V",
            },
            {
              id: "6-3",
              label: "C相线电压",
              node: "Uac",
              unit: "V",
            },
          ],
        },
        {
          id: "7",
          label: "电流",
          children: [
            {
              id: "7-1",
              label: "A相电流",
              node: "Ia",
              unit: "A",
            },
            {
              id: "7-2",
              label: "B相电流",
              node: "Ib",
              unit: "A",
            },
            {
              id: "7-3",
              label: "C相电流",
              node: "Ic",
              unit: "A",
            },
          ],
        },
      ],
      isActive: false,
      allNodeData: [],
      selectAll: false,
      
    };
  },
  computed: {
    //是否全选
    isSelectedAll() {
      let nodes = [];
      this.getNodes(nodes, this.treeData);
      let newVar =
        nodes.length === this.selectedNodes.length && nodes.length !== 0;
      return (this.selectAll = newVar);
    },
    
    //选择的node
    selectedNodes() {
      let obj = {};
      let nodes = [];
      this.getNodes(nodes, this.allNodeData);
      return nodes.filter((n) => {
        if (obj[n]) {
          return false;
        }
        obj[n] = n;
        return true;
      });
    },
    //路由名称
    routeName() {
      return this.$route.params.name;
    },
    //路由tag
    tag() {
      return this.$route.query.uid;
    },
    nextDayDisabled() {
      let timestamp = dateFormat("YY-mm-dd", new Date());
      let endtime = dateFormat("YY-mm-dd", this.date);
      if (this.radio === "year") {
        timestamp = dateFormat("YY", new Date());
        endtime = dateFormat("YY", this.date);
      } else if (this.radio === "month") {
        timestamp = dateFormat("YY-mm", new Date());
        endtime = dateFormat("YY-mm", this.date);
      }else if (this.radio === "week") {
        timestamp = dateFormat("YY-mm-dd", new Date());
        endtime = dateFormat("YY-mm-dd", addDay(this.date,5));
      }
      if (endtime >= timestamp) {
        return true;
      } else {
        return false;
      }
    },
  },
  async mounted() {
    let _this = this;
    if (this.tag == "PowerRange") {
      this.radio = "month"
    }else if (this.tag == "PowerTime") {
      this.radio = "month"
    }else{
      this.radio = "day"
    }
    //全选
    this.selectAll = true;
    this.currentChange(null, {
      checkedNodes: this.treeData,
    });
    this.$refs.tree.setCheckedNodes(this.treeData);
    window.onclick = () => {
      _this.isActive = false;
    };
    // if (this.tag == "Running" || this.tag == "Extremum") {
    //   this.currentChange(null, {
    //     checkedNodes: this.treeData[7].children,
    //   });
    //   this.$refs.tree.setCheckedNodes(this.treeData[7].children);
    // }
  },
  watch: {
    selectAll(n) {
      if (n) {
        this.$refs.tree.setCheckedNodes(this.treeData);
        this.allNodeData = this.$refs.tree
          .getCheckedNodes()
          .filter((e) => e.node);
      }
    },
    currentLoop(n, o) {},
    selectedLoops(n,o){
      //console.log(n,"更新数据")
    },
    tag(n) {
      if (this.tag == "PowerRange") {
        this.radio = "month"
      }else if (this.tag == "PowerTime") {
        this.radio = "month"
      }else{
        this.radio = "day"
      }
      this.selectAll = true;
      this.currentChange(null, {
        checkedNodes: this.treeData,
      });
      this.$refs.tree.setCheckedNodes(this.treeData);
      // if (n == "Running" || n == "Extremum") {
      //   this.clearTreeData()
      //   // this.allNodeData = this.treeData[7].children
      //   this.currentChange(null, {
      //     checkedNodes: this.treeData[7].children,
      //   });
      //   this.$refs.tree.setCheckedNodes(this.treeData[7].children);
      // }
    },
    radio(n) {
      this.date = new Date();
    },
  },
  methods: {
    currentChange(data, nodes) {
      this.allNodeData = nodes.checkedNodes.filter((e) => e.node);
    },
    clearTreeData() {
      this.selectAll = false;
      this.$refs.tree.setCheckedNodes([]);
      this.allNodeData = [];
    },
    getNodes(nodes, list) {
      list.forEach((e) => {
        let node = e.node;
        if (node) {
          nodes.push(node);
        }
        if (e.children) {
          this.getNodes(nodes, e.children);
        }
      });
    },
    checkreport(name){
      this.$router.replace({ name: 'HomePageOverview', query: { uid: name } })
    },
    perW(){
      let week = getAppointedDate(this.date,1, 1)
      this.date = new Date(week.startDate);
    },
    nextW(){
      let week = getAppointedDate(this.date,1,-1)
      this.date = new Date(week.startDate);
    },
    perD() {
      this.date = perDay(this.date);
    },
    nextD() {
      this.date = nextDay(this.date);
    },
    perM() {
      this.date = perMonth(this.date);
    },
    nextM() {
      this.date = nextMonth(this.date);
    },
    perY() {
      this.date = perYear(this.date);
    },
    nextY() {
      this.date = nextYear(this.date);
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-table{
  .el-table__fixed{
    // height: calc(100% - 17px) !important;
  }
}


.tree {
  width: 100%;
  background-color: #fff;
  transition: all 0.5s;
  overflow: hidden;
  box-shadow: 0 0 2px 0 #8c939d;

  .data {
    width: 100%;
    margin-top: 8rem;
    height: 100%;
  }

  .option {
    width: 100%;
    .h(40);
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    padding: 0 16rem;
    font-size: 14rem;
    font-weight: 300;
    color: #333333;
    line-height: 36rem;

    .all {
      cursor: pointer;

      img {
        // width: 16rem;
        // height: 16rem;
        margin-right: 8rem;
      }

      span {
        &:hover {
          color: rgba(13, 148, 255, 1);
        }
      }
    }

    > span {
      cursor: pointer;
      color: rgba(13, 148, 255, 1);
    }
  }
}

.reportag{
    font-size: 14px;
    span{
      height: 28px;
      line-height: 28px;
      background: #EAECED;
      border-radius: 4rem;
      text-align: center;
      padding: 0 15rem;
      display: inline-block;
      margin-right: 10rem;
      cursor: pointer;
    }
    .active{
      background: rgba(236, 247, 255, 1);
      color: #0D94FF;
    }
}
.el-dropdown-menu__item.active {
  color: #0d94ff;
}


.report {
  margin-top: 24rem;
  // .h(615);
  height:calc(100% - 70rem);
}

.reporth{
  height:calc(100% - 130rem);
}
.component.full{
  .reporth{
    height:calc(100% - 80rem);
  }
}
.btn {
  .w(96);
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 18px;
  font-weight: 400;
  color: #ffffff;
  background-color: #0d94ff;
  cursor: pointer;
  border-radius: 4rem;
  overflow: hidden;
  padding: 0px;
}

.per,
.next {
  background-color: #fff;
  font-size: 18rem;
  color: #666666;
  font-weight: 400;
  border: 1px solid rgba(0, 0, 0, 0.15);

  &:hover {
    background-color: #0d94ff;
    color: #ffffff;
  }
}

.el-button.is-plain:hover {
  background-color: #0d94ff !important;
  color: #ffffff !important;
  transition: 0s;
}

.el-button.is-active,
.el-button.is-plain:active,
.el-button.is-plain:focus {
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  color: #666666;
}

.el-button.is-disabled:hover {
  background-color: #ffffff !important;
  color: #c0c4cc !important;
  transition: 0s;
}

.per {
  margin-left: 8rem;
}
.next {
  margin-left: 8rem;
}
.nodes-tree,
.node-select,
.dateSelect {
  .w(180) !important;
  margin-right: 24rem;
  height: 40px;
}


.data-table {
  padding: 24rem;
  background-color: #fff;
  width: 100%;
  height: 100%;

  .menu {
    // margin-top: 24rem;
    .uleft{
      width: 80%;
      display: flex;
      flex-flow: row wrap;
      justify-content: flex-start;
      align-items: center;
      .both{
        margin-top: 10px;
      }
    }
        
    .export {
      img {
        margin-right: 7rem;
      }

      span {
        font-size: 18rem;
        font-weight: 500;
        color: #333333;
      }
    }

    .radio {
      

      .el-radio {
        margin-right: 20rem;
      }
    }
  }

  .title {
    font-size: 18rem;
    font-weight: bold;
    color: #333333;
  }
}
.el-select-dropdown__item{
  padding: 0;
  height: auto;
}

	/deep/.el-tree-node__content {
		.h(40) !important;
	}


</style>
